import { MouseEventHandler, ReactNode, useCallback } from 'react'

import { IItemTagProps } from './models/itemTagProps'

import styles from './ItemTag.module.scss'

export const ItemTag = ({ item, onCrossIconClick }: IItemTagProps) => {
  const handleClick = useCallback<MouseEventHandler<HTMLSpanElement>>(
    (e) => {
      e.stopPropagation()
      onCrossIconClick(item.itemId)
    },
    [onCrossIconClick, item]
  )

  return (
    <div className={styles.root}>
      <span className={styles.title}>{item.title as ReactNode}</span>
      <span className={styles.crossIcon} onClick={handleClick}>
        <i className="kbase kbase-close-circle" />
      </span>
    </div>
  )
}
